'use strict';
// Muslim Pro Games SDK — bridge.js v1
// Include this file in your game. Do not modify.

(function () {
  // Game → native: try iOS bridge, then Android bridge, then postMessage fallback (dev iframe).
  window.sendToHost = function (type, payload) {
    var msg = Object.assign({ source: 'mp-game', type: type, ts: Date.now() }, payload || {});
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.mpGameBridge) {
      window.webkit.messageHandlers.mpGameBridge.postMessage(msg);
    } else if (window.MpGameBridge) {
      window.MpGameBridge.postMessage(JSON.stringify(msg));
    } else {
      // Dev fallback — postMessage to parent iframe or self
      window.parent.postMessage(msg, '*');
    }
  };

  // Game → native: tracked analytics event (thin sugar over sendToHost).
  window.trackEvent = function (name, properties) {
    if (!name || typeof name !== 'string') return;
    window.sendToHost('analytics:event', {
      name: name,
      properties: properties && typeof properties === 'object' ? properties : {},
    });
  };

  // Native → game: native calls window.mpGameReceive(msg) via evaluateJavaScript.
  // Delegates to window.gameReceive, which the game must implement.
  window.mpGameReceive = function (msg) {
    if (typeof window.gameReceive === 'function') window.gameReceive(msg);
  };

  // Dev fallback: also accept postMessage (for testing in browser without native).
  window.addEventListener('message', function (e) {
    if (typeof window.gameReceive === 'function') window.gameReceive(e.data);
  });

  // ── Hub navigation ────────────────────────────────────────────────────────
  // The games hub lives at the site root ("/") and links into each game. A
  // player who arrived from the hub can step back to it; a player whose native
  // app deep-links straight into a game (older app versions — there was no hub)
  // has no hub in history, so we ask the host to dismiss the WebView instead.
  // This keeps the pre-hub contract intact for older shells.
  window.mpCameFromHub = function () {
    try {
      if (!document.referrer) return false;
      var ref = new URL(document.referrer);
      return ref.origin === window.location.origin && ref.pathname === '/';
    } catch (e) {
      return false;
    }
  };

  // Leave the game: back to the hub when we came from it, otherwise tell the
  // host to close the WebView (legacy deep-link entry).
  window.mpExitToHub = function () {
    if (window.mpCameFromHub()) window.history.back();
    else window.sendToHost('navigation:exit');
  };
})();
